var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"fa",class:Object.assign({}, {'fa-check-square-o': _vm.checked, 'fa-square-o': !_vm.checked}, _vm.sizeObject)})}
var staticRenderFns = []

export { render, staticRenderFns }